import React, { useState, useEffect, Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { Link, useHistory } from 'react-router-dom';
import account from '../../assets/image/account.png';
import docsearch from '../../assets/image/docsearch.png';
import searchResultImg from '../../assets/image/searchResult.png';
import seqDb from '../../assets/image/seqDb.png';
import seqSearch from '../../assets/image/seqSearch.png';
import seqTool from '../../assets/image/seqTool.png';
import { url } from '../../reducers/url';
import { useSelector } from 'react-redux';
import SavedSearch from '../../services/savedsearch';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import Tooltip from "@material-ui/core/Tooltip";
import Beta from '../../shared/components/Beta';

const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
        width: '96%',
        margin: '30px auto',
        minHeight: '360px',
        borderBottom: '1px solid #cec7c7'
    },
    savedForm: {
        backgroundColor: '#f5f2f2',
        // paddingLeft: "30px",
        // paddingTop: "34px",
        padding: '30px',
        height: '100%'
    },
    savedFormDark: {
        backgroundColor: '#56545473',
        // paddingLeft: "30px",
        // paddingTop: "34px",
        padding: '30px',
        height: '100%'
    },
    anchorTag: {
        // textDecoration: 'none !important',
        // color: "#008EC5",
        // fontSize:"15px",
        // cursor: 'pointer',

        // width: 80px;
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        display: 'block',
        textOverflow: 'ellipsis'
        // line-height: 55px;
    },
    p: {
        color: "#008EC5",
        size: "20px"
    },
    textHeading: {
        fontWeight: "700 !important",
        marginBottom: "5px"
    },
    columnPadding: {
        paddingTop: '5px',
        paddingLeft: '20px'
    },
    pTagMargin: {
        marginBottom: "0px",
        // fontWeight: "500",
        // '& span':{
        //     color: "#5A6868",
        // }
    },
    applicationPanelRow: {
        marginBottom: "15px",
        minHeight: '70px'
    },
    appIcon: {
        fontSize: '50px',
        color: '#5A6868'
    }
}));

function ApplicationPanel() {
    const { t, i18n } = useTranslation('common');
    const history = useHistory();
    const [searchFormsData, setSearchFormsData] = useState([]);

    const classes = useStyles();
    const userInfo = useSelector(state => state.setUserInfo);
    const toggle = useSelector(state => state.setToggle.toggle);
    const videoToggle = useSelector(state => state.setVideoToggle.videoToggle);
    const [userData, setUserData] = useState();

    // reset login status
    useEffect(() => {
        (async () => {
            const result = await SavedSearch.getSavedSearchData();
            if (result && result.response_content && result.response_content.templates) {
                const dta = await result.response_content.templates;
                setSearchFormsData(dta);
            }
        })()
        if (userInfo && userInfo.current_user) {
            setUserData(userInfo);
        }
    }, [userInfo]);
    function showString(str) {
        let getLength = str.length;
        if (getLength > 23) {
            str = str.substring(0, 23) + ' ...';
        }
        return str;

    }
    function accountInfoForm() {
        history.push('/accountsettings')
    }
    function changePasswordForm() {
        history.push('/changepassword')
    }
    function searchForm() {
        history.push('/search')

    }



    return (
        <div className={classes.grow}>
            {/* <Container className="p-0 m-5"> */}
            <Row>
                <Col md="3" sm="3" xs='3' className="mb-3">
                    <div className={toggle ? classes.savedForm : classes.savedFormDark}>
                        <p className={'subHeading ' + classes.textHeading}>{t('savedSearchForms')}</p>
                        {searchFormsData && searchFormsData.length > 0 && searchFormsData.map((dbVal, index) => {
                            if (index <= 8) {
                                let enCodeDBVal = dbVal.name.toString().replace(/%/g, '~~GQSF~~');
                                enCodeDBVal = encodeURI(enCodeDBVal);
                                return (
                                    <Fragment>
                                        { dbVal.type === 'GqWfIpSearch_launch' &&
                                                <Fragment>
                                                    <Link to={"/ipseqsearch/template/" + encodeURIComponent(enCodeDBVal)} >
                                                        <span className={classes.anchorTag}> {dbVal.name}</span>

                                                    </Link>
                                                </Fragment>}
                                        { dbVal.type === 'GqWfVMIpSearch_launch' &&
                                                <Fragment>
                                                    <Link to={"/ipseqvariation/template/" + encodeURIComponent(dbVal.name)} >
                                                        <span className={classes.anchorTag}> {dbVal.name}</span>
                                                    </Link>
                                                </Fragment>
                                        }
                                        { dbVal.type === 'GqWfABIpSearch_launch' &&
                                            <Fragment>
                                                <Link to={"/searchresantibody/template/" + encodeURIComponent(dbVal.name)} >
                                                    <span className={classes.anchorTag}> {dbVal.name}</span>
                                                </Link>
                                            </Fragment>
                                        }
                                        { dbVal.type === 'GqWfCmSearch_launch' &&
                                            <Fragment>
                                                <Link to={"/cmsearch/template/" + encodeURIComponent(dbVal.name)} >
                                                    <span className={classes.anchorTag}> {dbVal.name}</span>
                                                </Link>
                                            </Fragment>
                                        }
                                    </Fragment>
                                )
                            }
                        })
                        }

                        <br></br>
                        <p className={classes.pTagMargin}><a className={"moreLink " + classes.anchorTag + ' appLink'} onClick={searchForm}>Manage ...</a></p>
                    </div>

                </Col>
                <Col md="4" sm="4" xs='4' className={classes.columnPadding}>
                    <p className={'subHeading ' + classes.textHeading}>{t('sequenceSearch')}
                    {videoToggle && <Tooltip title="Video help for launching a Sequence Search" arrow>
                        <a href="https://share.vidyard.com/watch/QXb6ko3N4Bw9rhjPJzxzn6"
                                target="_blank" className="appTextFont appLink" rel="noreferrer">
                                    <PlayCircleOutlineIcon  style={{paddingBottom: '3px', color: 'darkorange',marginBottom: '1px'}} /></a></Tooltip>}</p>
                    <Row className={classes.applicationPanelRow}>
                        <Col lg="2" md="2" sm="2" xs='2' className="pr-0">
                            {/* <AccessAlarm className={classes.appIcon} /> */}
                            <img src={seqSearch} alt="seqSearch" className="w-100" />
                        </Col>
                        <Col lg="10" md="10" sm="10" xs='10'>
                            <p className={classes.pTagMargin}>
                                <Link to="/ipseqsearch" className={classes.anchorTag + ' appLink'}>{t('ipSequence')}</Link>
                            </p>
                            <p className={classes.pTagMargin}>
                                <Fragment>
                                    {userData && !userData.vmAccess && <span className={classes.pTagMargin + " bodyText"}>{t('sequenceVariation')}</span>}
                                    {userData && userData.vmAccess && <Link to="/ipseqvariation" className={classes.anchorTag + ' appLink'}>{t('sequenceVariation')}</Link>}
                                </Fragment>
                            </p>
                            <p className={classes.pTagMargin}>
                                <Fragment>
                                    {userData && !userData.abAccess && <span className={classes.pTagMargin + " bodyText"}>{t('antibodySequence')}</span>}
                                    {userData && userData.abAccess && <Link to="/searchresantibody" className={classes.anchorTag + ' appLink'}>{t('antibodySequence')}</Link>}
                                </Fragment>
                            </p>
                            <p className={classes.pTagMargin}>
                                <Fragment>
                                    {userData && !userData.cmAccess && <span  style={{display: "flex"}} className={"bodyText"}><span>{t('cmSequence')}</span></span>}
                                    {userData && userData.cmAccess && <span style={{display: "flex"}}><Link to="/cmsearch" className={classes.anchorTag + ' appLink'}>{t('cmSequence')}</Link></span>}
                                </Fragment>
                            </p>
                            {/* <p className={classes.pTagMargin}>
                                <Link to="/gqsearch" className={classes.anchorTag + ' appLink'}>GQ Search Assistant</Link>
                            </p> */}
                        </Col>
                    </Row>
                    <p className={'subHeading ' + classes.textHeading}>{t('documentSearch')}</p>
                    <Row className={classes.applicationPanelRow}>
                        <Col lg="2" md="2" sm="2" xs='2' className="pr-0">
                            <img src={docsearch} alt="docsearch" className="w-100" />
                        </Col>
                        <Col lg="10" md="10" sm="10" xs='10'>
                            {/* <p className={classes.pTagMargin}><a className={classes.anchorTag + ' appLink'} href='#' onClick={e => e.preventDefault()}>{t('patentFullText')}</a></p> */}
                            <p className={classes.pTagMargin}>
                                <Fragment>
                                    {userData && !userData.ftAccess && <span className={classes.pTagMargin + " bodyText"}>{t('patentFullText')}</span>}
                                    {userData && userData.ftAccess && <Link to="/fulltextsearch" className={classes.anchorTag + ' appLink'}>{t('patentFullText')}</Link>}
                                </Fragment>
                            </p>
                            <p className={classes.pTagMargin}>
                                <Fragment>
                                    {userData && <Link to="/patentnumbersearch" className="appLink">{t('patentNumbers')}</Link>}
                                </Fragment>
                            </p>
                            {userData && userData.kwAccess &&
                                <p className={classes.pTagMargin}>
                                    <Fragment>
                                        <Link to="/kwsearch" className={classes.anchorTag + ' appLink'}>Patent Numbers V2<Beta/></Link>
                                    </Fragment>
                                </p>
                            }
                            <p className={classes.pTagMargin}>
                                <Fragment>
                                    <Link to="/UserSearchTerms" className={classes.anchorTag + ' appLink'}>{t("Search Terms")}</Link>
                                </Fragment>
                            </p>
                        </Col>
                    </Row>
                    <p className={'subHeading ' + classes.textHeading}>{t('sequenceDatabases')}</p>
                    <Row className={classes.applicationPanelRow}>
                        <Col lg="2" md="2" sm="2" xs='2' className="pr-0">
                            <img src={seqDb} alt="seqDb" className="w-100" />
                        </Col>
                        <Col lg="10" md="10" sm="10" xs='10'>
                            {/* <p className={classes.pTagMargin}><a className={classes.anchorTag + ' appLink'} href={process.env.REACT_APP_API_URL + url.browserDBLink} target="_blank" rel="noreferrer">{t('browseDatabases')}</a></p> */}
                            <p className={classes.pTagMargin}>
                                <Link className={classes.anchorTag + ' appLink'} to='/browseDatabase'>{'Browse Databases'}</Link>
                            </p>
                            <p className={classes.pTagMargin}>
                                <Link className={classes.anchorTag + ' appLink'} to='/personaldb'>{t('personalDatabases')}</Link>
                            </p>
                            <p className={classes.pTagMargin}>
                                <Fragment>
                                    {userData && !userData.smAccess && <span className={classes.pTagMargin + " bodyText"}>{t('sequenceManagement')}</span>}
                                    {userData && userData.smAccess && <a className={classes.anchorTag + ' appLink'} href={process.env.REACT_APP_API_URL + url.sequenceManagement} target="_blank" rel="noreferrer">{t('sequenceManagement')}</a>}
                                </Fragment>
                            </p>
                            <p className={classes.pTagMargin}>
                                <Fragment>
                                    {userData && !userData.smAccess && <span className={classes.pTagMargin + " bodyText"}>{t('ilsManagement')}</span>}
                                    {userData && userData.smAccess && <a className={classes.anchorTag + ' appLink'} href={process.env.REACT_APP_API_URL + url.ilsManagement} target="_blank" rel="noreferrer">{t('ilsManagement')}</a>}
                                </Fragment>
                            </p>
                        </Col>
                    </Row>
                </Col>
                <Col md="4" sm="4" xs='4' className={classes.columnPadding}>
                    <p className={'subHeading ' + classes.textHeading}>{t('searchResults')}</p>
                    <Row className={classes.applicationPanelRow}>
                        <Col lg="2" md="2" sm="2" xs='2' className="pr-0">
                            <img src={searchResultImg} alt="searchResult" className="w-100" />
                        </Col>
                        <Col lg="10" md="10" sm="10" xs='10'>
                            <p className={classes.pTagMargin}>
                                <Link className={classes.anchorTag + ' appLink'} to='/searchResult'>{t('allSearchResults')}</Link>

                            </p>


                        </Col>
                    </Row>
                    <p className={'subHeading ' + classes.textHeading}>{t('sequenceTools')}</p>
                    <Row className={classes.applicationPanelRow}>
                        <Col lg="2" md="2" sm="2" xs='2' className="pr-0">
                            <img src={seqTool} alt="seqTool" className="w-100" />
                        </Col>
                        <Col lg="10" md="10" sm="10" xs='10'>
                            <p className={classes.pTagMargin}>
                                <Link className={classes.anchorTag} to='alignSequencesDirectly'>{t('alignSequencesDirectly')}</Link>
                            </p>
                            {/* <a className={classes.anchorTag + ' appLink'} href={process.env.REACT_APP_API_URL + url.alignSequencesDirectly} target="_blank" rel="noreferrer">{t('alignSequencesDirectly')}</a> */}
                            {/* <p className={classes.pTagMargin}><a className={classes.anchorTag+' appLink'} href='#' onClick={e => e.preventDefault()}>{t('convertSequenceFormats')}</a></p> */}
                            <p className={classes.pTagMargin}>
                                <Link className={classes.anchorTag} to='convertsequence'>{t('convertSequenceFormats')}</Link>
                            </p>
                            <p className={classes.pTagMargin}>
                                <Link className={classes.anchorTag} to='clustalo'>{t('clustalo')}</Link>
                            </p>
                        </Col>
                    </Row>
                    <p className={'subHeading ' + classes.textHeading}>{t('myAccount')}</p>
                    <Row className={classes.applicationPanelRow}>
                        <Col lg="2" md="2" sm="2" xs='2' className="pr-0">
                            <img src={account} alt="account" className="w-100" />
                        </Col>
                        <Col lg="10" md="10" sm="10" xs='10'>
                            <p className={classes.pTagMargin}><a onClick={accountInfoForm}>{t('accountInformation')}</a></p>
                            <p className={classes.pTagMargin}><a className={classes.anchorTag + ' appLink'} onClick={changePasswordForm}>{t('changePassword')}</a></p>
                        </Col>
                    </Row>
                </Col>
            </Row>
            {/* </Container> */}

        </div>

    );
}

export default ApplicationPanel;
